module.exports = __webpack_public_path__ + "img/2.f0f8ec37.jpg";